import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import {
  Drawer,
  Button,
  PageHeader,
} from "antd";
import { useState } from "react";

import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import ProgrammeList from "../../components/masters/programme/ProgrammeList";

const Programme = () => {
    // const [visible, setVisible] = useState(false);

    // const [paymentModeAddData, setPaymentModeAddData] = useState({
    //  id: 0,
    //  payment_mode: '',
    //  account_id: '',
    //  mode: ADD_MODE
    // });
  
    // const showDrawer = () => {
    //   setVisible(true);
    // };
  
    // const onClose = () => {
    //   setVisible(false);
    // };
  
  
    return (
      <div className="inside-main-content">
        <AdminBreadCrumb />
  
        <div className="box-style">
          <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="Programme"
            subTitle=""
            extra={[
            //   <Button key="1" type="primary" shape="round" onClick={showDrawer}>
            //     <PlusOutlined /> Add
            //   </Button>,
            ]}
          ></PageHeader>
  
          {/* <Drawer
            title="Add new payment mode"
            width="478px"
            onClose={onClose}
            visible={visible}
            bodyStyle={{
              paddingBottom: 80,
            }}
            destroyOnClose={true}
          >
            <PaymentModeEntry data={paymentModeAddData} />
          </Drawer> */}

          <div className="tableView">
          <div className="form-content">
            <ProgrammeList />
          </div>
          </div>
  
        </div>
      </div>
    )
}

export default Programme